module.exports = __webpack_public_path__ + "img/2REDBERRIES.ace1b388.png";